/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Container from "./components/Container";
import Holiday from "./components/Holiday";
import Team from "./components/Team";
import TeamWaiting from "./components/TeamWaiting";
import TeamActionApprove from "./components/TeamAction/approve";
import TeamActionReject from "./components/TeamAction/reject";
import Hr from "./components/Hr";
import HrAssign from "./components/HrAssign";
import Setting from "./components/Setting";
import Org from "./components/Org";
import OrgUnit from "./components/OrgUnit";
import Probation from "./components/Probation";
import API from "./utils/API";
import Func from "./utils/Func";
import PreviewLoginInput from "./PreviewLoginInput";

window.$google_email = "";
window.$user_profile = {};

const VirtualPath = () => {
  const {
    googleProfile,
    setGoogleProfile,
    userProfile,
    setUserProfile,
    checkIsAdminPreview } = useAuth();

  const handlePreview = (val) => {
    const nextEmail = String(val || "").trim();
    if (!nextEmail || !nextEmail.includes("@")) {
      alert("Please enter a valid email address.");
      return;
    }

    if (checkIsAdminPreview()) {
      if (nextEmail === googleProfile?.email) {
        return;
      }
      setUserProfile({});
      setGoogleProfile((prev) => ({
        ...prev,
        email: nextEmail,
        keyChange: (prev?.keyChange || 0) + 1 }));
    }
  };

  const handleReset = () => {
    if (checkIsAdminPreview()) {
      const nextEmail = String(googleProfile?.authEmail || "").trim();
      if (!nextEmail || nextEmail === googleProfile?.email) {
        return;
      }
      setUserProfile({});
      setGoogleProfile((prev) => ({
        ...prev,
        email: nextEmail,
        keyChange: (prev?.keyChange || 0) + 1 }));
    }
  };

  const pathname = window.location.pathname || "";
  const isProbationPath =
    pathname === "/hrms/probation" ||
    pathname === "/hrms/probation/" ||
    pathname.startsWith("/hrms/probation/");

  useEffect(() => {
    if (googleProfile?.email != "") {
      const mainFunc = async () =>
        await API.post("user", {
          params: {
            email: googleProfile?.email,
            path: window.location.pathname } });
      mainFunc()
        .then((res) => {
          const decrypt = (res?.data);
          if (decrypt?.status === "success" && decrypt?.idu) {
            setUserProfile(decrypt);
          } else {
            setUserProfile({
              err: 1,
              err_msg: `Failes : ` + decrypt?.err_msg ?? "" });
          }
        })
        .catch((err) => {
          setUserProfile({ err: 1, err_msg: `Failes : ${err}` });
        });
    }
  }, [googleProfile?.email]);

  if (googleProfile?.email === "" && googleProfile?.err === 0) {
    return VirtualPathFunc.HtmlPageLoading();
  }
  if (googleProfile?.err === 1) {
    return VirtualPathFunc.HtmlPageError(googleProfile.err_msg);
  }
  if (userProfile?.err === 1) {
    return VirtualPathFunc.HtmlPageError(userProfile.err_msg);
  }
  window.$google_email = googleProfile.email;
  if (!Func.IsEmptyObject(userProfile)) {
    window.$user_profile = userProfile;
    if (
      !googleProfile?.isAdmin &&
      process.env.REACT_APP_SYSTEM_CLOSED === "true"
    ) {
      return (
        <div id="container" className="container" style={{ width: "99%" }}>
          <div
            style={{
              textAlign: "center",
              fontSize: "2rem",
              color: "#333",
              marginTop: "0%",
              fontFamily: "Arial, sans-serif" }}
          >
            <p>
              We regret to inform you that our system is temporarily
              unavailable.
            </p>
            <p>
              We will resume operations on <strong>Monday</strong>.
            </p>
            <p>
              We apologize for any inconvenience and appreciate your
              understanding.
            </p>
          </div>
        </div>
      );
    }

    return (
      <div key={"router-content-" + googleProfile.keyChange}>
        {checkIsAdminPreview() && !isProbationPath && (
          <PreviewLoginInput
            defaultValue={googleProfile.email}
            onApply={handlePreview}
            onReset={handleReset}
            label="Preview Login as:"
            placeholder="Enter user email"
            buttonText="Apply"
          />
        )}
        <Router>
          <Switch>
            <Route exact path="/hrms/holiday/" component={Holiday} />
            <Route exact path="/hrms/team/waiting/" component={TeamWaiting} />
            <Route
              exact
              path="/hrms/team/approve/:reqId"
              component={TeamActionApprove}
            />
            <Route
              exact
              path="/hrms/team/reject/:reqId"
              component={TeamActionReject}
            />
            <Route exact path="/hrms/team/summary/" component={Team} />
            <Route exact path="/hrms/team/request/" component={Team} />
            <Route exact path="/hrms/team/" component={Team} />
            <Route exact path="/hrms/hr/assign/" component={HrAssign} />
            <Route exact path="/hrms/hr/" component={Hr} />
            <Route exact path="/hrms/setting/" component={Setting} />
            <Route exact path="/hrms/org/" component={Org} />
            <Route exact path="/hrms/org/unit/" component={OrgUnit} />
            <Route
              exact
              path="/hrms/probation/:userId/"
              component={Probation}
            />
            <Route exact path="/hrms/probation/:userId" component={Probation} />
            <Route exact path={["/hrms", "/hrms/"]} component={Container} />
          </Switch>
        </Router>
      </div>
    );
  }
  return VirtualPathFunc.HtmlPageLoading();
};
const VirtualPathFunc = {
  HtmlPageError(err_msg) {
    const message = String(err_msg || "");
    const isPopupBlocked = message
      .toLowerCase()
      .includes("browser blocked google login popup");

    if (isPopupBlocked) {
      return (
        <div className="container app-error-container">
          <div className="app-error-card">
            <div className="app-error-badge">SIGN-IN REQUIRED</div>
            <h4 className="app-error-title app-error-title-blocked">
              Popup blocked by browser
            </h4>
            <p className="app-error-message app-error-message-blocked">
              Browser blocked Google login popup. Please allow popups for this site, then refresh and try again.
            </p>
            <ol className="app-error-steps">
              <li>Allow popups for this site in your browser settings.</li>
              <li>Refresh this page and try sign-in again.</li>
            </ol>
            <button
              type="button"
              className="app-error-refresh-btn"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    let html = (
      <div className="container app-error-container">
        <div className="app-error-card">
          <h4 className="app-error-title">Authentication Error</h4>
          <p className="app-error-message">{message || "Unknown error"}</p>
          <p className="app-error-hint">
            Please verify your login session and browser popup/cookie settings, then try again.
          </p>
          <button
            type="button"
            className="app-error-refresh-btn"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        </div>
      </div>
    );
    return html;
  },
  HtmlPageLoading() {
    let html = (
      <div className="container app-loading-container">
        <div className="app-loading-card">
          <div className="app-loading-spinner" />
          <div className="app-loading-title">Loading...</div>
          <div className="app-loading-subtitle">Checking your session</div>
        </div>
      </div>
    );
    return html;
  } };

export { VirtualPath, VirtualPathFunc };


